import { createContext, useState, useCallback } from 'react';

export const AuthFormContext = createContext();

export function AuthFormProvider({ children }) {
    const [formState, setFormState] = useState({
        email: '',
        password: '',
    });

    const updateField = useCallback((field, value) => {
        setFormState((prev) => ({ ...prev, [field]: value }));
    }, []);

    return (
        <AuthFormContext.Provider value={{ formState, updateField }}>
            {children}
        </AuthFormContext.Provider>
    );
}

AuthFormContext.displayName = 'AuthFormContext';
